// @vendors
import React from 'react';
import PropTypes from 'prop-types';

import './contractErrorModal.override.scss'

// @commons
import { ContentBox } from 'commonsComponents/contentBox'
import OKModal from 'components/commons/OKModal/OKModal'

const ContractErrorModal = ({ title, description, onSubmit, hasCloseButton, showModal }) => {
    const handleSubmit = () => {
        onSubmit();
    }

    const buildModalErrorContent = () => {
        return (
            <ContentBox
                title={title}
                customClassName="contract-error-modal"
                hasShadow={false}
            >
                <div className="contract-error-modal__wrapper">
                    <p className="contract-error-modal__text">{description}</p>
                </div>
            </ContentBox>
        );
    }

    const buildModal = () => {
        return (
            <OKModal
                content={buildModalErrorContent()}
                contentOverflow="auto"
                footerType="action"
                isOpen={showModal}
                shouldCloseOnOverlayClick={false}
                onCloseCallback={hasCloseButton && handleSubmit}
                customCloseButton={!hasCloseButton}
                overlayClassName="contract-error-modal"
                onPrimaryButtonClick={handleSubmit}
                primaryButtonText="common-understood"
            />
        )
    }

    return (
        <div>
            {buildModal()}
        </div>
    )
}

ContractErrorModal.propTypes = {
    description: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    hasCloseButton: PropTypes.bool,
    showModal: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
};

ContractErrorModal.defaultProps = {
    hasCloseButton: true
};

module.exports = ContractErrorModal;
